import React, { useState, useEffect, useRef } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
// import { useAppContext } from 'providers/AppProvider';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import moment from 'moment';
import { getJobDetails, updateJobTable } from 'nursd-dashboard/api/jobTable';
import { sendNotification } from 'nursd-dashboard/api/webNotification';
import { toast } from 'react-toastify';
// import FalconReactRange from 'components/doc-components/FalconReactRange';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import {
  licenseTypes,
  optionsCertification,
  optionsEMR,
  optionsExperienceLevel,
  optionsSpecialty,
  duration,
  slots,
  jobTypes
} from 'nursd-dashboard/data/defaultData';
import { getAllFacilityOrgList } from 'nursd-dashboard/api/organizationTable';
import { getCustomerTableList } from 'nursd-dashboard/api/customerTable';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getAllNurseList,
  getJobMatchedAllNurse,
  getNurseWeekAvailabilityForDirectAssignment
} from 'nursd-dashboard/api/nurseTable';
import UserJobCard from './UserJobCard';
import { getTemplateType } from 'nursd-dashboard/api/jobTemplate';
import { socket } from 'nursd-dashboard/api/socket';
import { postNurseNotification } from 'nursd-dashboard/api/nurseNotification';
import Flex from 'components/common/Flex';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import { timeDifferentFun } from 'nursd-dashboard/utils/function';
import TimeDropdown from '../create_schedule/TimeDropdown';

const GOOGLE_PLACES_API_KEY = 'AIzaSyASXZSrsvL25WiY7nZc2M4WJhkDMj-jkvs';
const mapApiJs = 'https://maps.googleapis.com/maps/api/js';

function loadAsyncScript(src) {
  return new Promise(resolve => {
    const script = document.createElement('script');
    Object.assign(script, {
      type: 'text/javascript',
      async: true,
      src
    });
    script.addEventListener('load', () => resolve(script));
    document.head.appendChild(script);
  });
}

const extractAddress = place => {
  const address = {
    street_number: '',
    route: '',
    locality: '',
    administrative_area_level_3: '',
    administrative_area_level_2: '',
    administrative_area_level_1: '',
    country: '',
    postal_code: '',
    postal_code_suffix: '',
    latitude: '',
    longitude: '',
    plain() {
      const street_number = this.street_number ? this.street_number + ', ' : '';
      const route = this.route ? this.route + ', ' : '';
      const locality = this.locality ? this.locality + ', ' : '';
      const administrative_area_level_3 = this.administrative_area_level_3
        ? this.administrative_area_level_3 + ', '
        : '';
      const administrative_area_level_2 = this.administrative_area_level_2
        ? this.administrative_area_level_2 + ', '
        : '';
      const administrative_area_level_1 = this.administrative_area_level_1
        ? this.administrative_area_level_1 + ', '
        : '';
      const country = this.country ? this.country + ', ' : '';
      const postal_code = this.postal_code ? this.postal_code + ', ' : '';
      const postal_code_suffix = this.postal_code_suffix
        ? this.postal_code_suffix + ', '
        : '';
      return (
        street_number +
        route +
        locality +
        administrative_area_level_3 +
        administrative_area_level_2 +
        administrative_area_level_1 +
        country +
        postal_code +
        postal_code_suffix
      );
    }
  };

  if (!Array.isArray(place?.address_components)) {
    return address;
  }

  place.address_components.forEach(component => {
    const types = component.types;
    const value = component.long_name;

    if (types.includes('street_number')) {
      address.street_number = value;
    }
    if (types.includes('route')) {
      address.route = value;
    }
    if (types.includes('locality')) {
      address.locality = value;
    }
    if (types.includes('administrative_area_level_3')) {
      address.administrative_area_level_3 = value;
    }
    if (types.includes('administrative_area_level_2')) {
      address.administrative_area_level_2 = value;
    }
    if (types.includes('administrative_area_level_1')) {
      address.administrative_area_level_1 = value;
    }
    if (types.includes('country')) {
      address.country = value;
    }
    if (types.includes('postal_code')) {
      address.postal_code = value;
    }
    if (types.includes('postal_code_suffix')) {
      address.postal_code_suffix = value;
    }
  });

  let points = Object.keys(place?.geometry?.viewport);

  address.latitude = place?.geometry?.viewport?.[points[0]]?.lo;
  address.longitude = place?.geometry?.viewport?.[points[1]]?.lo;

  return address;
};

const Create_Schedule = () => {
  const navigate = useNavigate();
  const { jobId } = useParams();
  // const {
  //   config: { isDark }
  // } = useAppContext();

  const searchInput = useRef(null);
  const { authToken, location, organization } = useAuth();

  useEffect(() => {
    initMapScript().then(() => initAutocomplete());
  }, []);

  const animatedComponents = makeAnimated();

  const [loading, setLoading] = useState(true);

  const [managers, setManagers] = useState([]);
  const [customers, setCustomers] = useState([]);
  // const [nurseList, setNurseList] = useState([]);
  // const nurseList = [];

  const [jobTemplateArray, setJobTemplateArray] = useState([]);
  const [selectedJobTemplate, setSelectedJobTemplate] = useState([]);
  const [valueLicense, setValueLicense] = useState([]);
  const [valueManager, setValueManager] = useState([]);
  const [valueJobTypes, setValueJobTypes] = useState({
    value: '1',
    label: 'Shift'
  });
  const [valueCustomer, setValueCustomer] = useState([]);
  const [valueSpecialty, setValueSpecialty] = useState([]);
  const [valueCertification, setValueCertification] = useState([]);
  const [valueEMR, setValueEMR] = useState([]);
  const [valueExperienceLevel, setValueExperienceLevel] = useState([]);
  const [valueDuration, setValueDuration] = useState([]);
  const [valueSlots, setValueSlots] = useState([]);
  const [availableNurse, setAvailableNurse] = useState([]);
  const [availableNurseLoading, setAvailableNurseLoading] = useState(false);

  const [selectedWeeks, setSelectedWeeks] = useState('1');
  // const [type, settType] = useState('Shift');
  // const [duration, setDuration] = useState([1]);

  const [
    weekNurseDirectAssignmentAvailabilityData,
    setWeekNurseDirectAssignmentAvailabilityData
  ] = useState([]);

  const [jobFinalSelectionNurseId, setJobFinalSelectionNurseId] = useState('');
  const [loadingButton, setLoadingButton] = useState(false);
  const [jobCreated, setJobCreated] = useState(false);
  const [userList, setUserList] = useState([]);
  const [job, setJob] = useState(undefined);

  const [formData, setFormData] = useState({
    shiftTitle: '',
    startDate: new Date(),
    endDate: new Date(),
    break: 'No Break',
    customerName: null,
    customerId: '',
    unit: '',
    floor: '',
    fullAddress: '',
    latitude: '',
    longitude: '',
    notes: '',
    jobType: 'Shift',
    jobTiming: '',
    customerVisibility: false,
    autoAccept: false,
    slots: false,
    baseRate: '',
    maxBaseRate: '',
    baseRateEnable: false,
    enableBid: false,
    publishJob: false,
    template: false,
    jobTemplateName: '',
    jobPostingTableFacilityTableId: '',
    jobPostingTableFacilityTableName: '',
    specialtyRequired: false,
    certificationRequired: false,
    experienceRequired: false,
    emrehrRequired: false,
    directAssignment: false
  });

  const getJobDetail = async id => {
    await getJobDetails(authToken, id)
      .then(async res => {
        setJob(res);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (job) {
      const filteredManager = managers?.filter(
        type =>
          parseInt(type?.value) ===
          parseInt(job?.jobPostingTableFacilityTableId)
      );
      setValueManager(filteredManager[0]);

      // Create the updated formData object

      const startTime = moment(job?.startTime);

      // Get the AM/PM format
      const startTimeAMPM = startTime.format('A'); // 'AM' or 'PM'

      // Get the hour in 12-hour format
      let shour = parseInt(startTime.format('hh'));

      // Adjust hour based on AM/PM
      if (startTimeAMPM === 'PM' && shour < 12) {
        shour += 12; // Convert PM hours to 24-hour format
      } else if (startTimeAMPM === 'AM' && shour === 12) {
        shour = 0; // Handle 12 AM case
      }

      // Create the endDate with adjusted hour
      const startDate = new Date(
        moment(job?.startDate).format('YYYY'),
        moment(job?.startDate).format('MM') - 1,
        moment(job?.startDate).format('DD'),
        shour,
        moment(job?.startTime).format('mm'),
        moment(job?.startTime).format('ss'),
        0
      );

      const endTime = moment(job?.endTime);

      // Get the AM/PM format
      const endTimeAMPM = endTime.format('A'); // 'AM' or 'PM'

      // Get the hour in 12-hour format
      let hour = parseInt(endTime.format('hh'));

      // Adjust hour based on AM/PM
      if (endTimeAMPM === 'PM' && hour < 12) {
        hour += 12; // Convert PM hours to 24-hour format
      } else if (endTimeAMPM === 'AM' && hour === 12) {
        hour = 0; // Handle 12 AM case
      }

      // Create the endDate with adjusted hour
      const endDate = new Date(
        moment(job?.endDate).format('YYYY'),
        moment(job?.endDate).format('MM') - 1,
        moment(job?.endDate).format('DD'),
        hour, // Use the adjusted hour
        moment(job?.endTime).format('mm'),
        moment(job?.endTime).format('ss'),
        0
      );

      const filterDuration = duration?.filter(
        type => type?.value === timeDifferentFun(startDate, endDate)
      );
      setValueDuration(filterDuration);

      // console.log(moment(startDate).toString());
      let e = moment(startDate).add('hours', filterDuration[0]?.value);
      // console.log(moment(e).toString());

      const updatedFormData = {
        ...formData,
        shiftTitle: job?.shiftTitle,
        break: 'No Break',
        customerName: job?.customerName,
        customerId: job?.customerId,
        unit: job?.unit,
        floor: job?.floor,
        fullAddress: job?.fullAddress,
        latitude: job?.latitude,
        longitude: job?.longitude,
        notes: job?.notes,
        jobType: 'Shift',
        jobTiming: '',
        customerVisibility: job?.customerVisibility,
        autoAccept: job?.autoAcceptedEnable,
        baseRate: job?.baseRate,
        maxBaseRate: job?.maxBidAmount,
        baseRateEnable: !!job?.baseRate,
        enableBid: job?.enableBid,
        jobTemplateName: '',
        specialtyRequired: job?.specialtyRequired,
        certificationRequired: job?.certificationRequired,
        experienceRequired: job?.experienceRequired,
        emrehrRequired: job?.emrehrRequired,
        jobPostingTableFacilityTableId: job?.jobPostingTableFacilityTableId,
        jobPostingTableFacilityTableName: filteredManager[0]?.name,
        startDate: startDate,
        endDate: new Date(e)
      };

      setFormData(updatedFormData);

      const filteredLicenseTypes = licenseTypes.filter(type =>
        job?.licenseType?.includes(type.label)
      );
      setValueLicense(filteredLicenseTypes);

      const filteredTypes = jobTypes?.filter(
        type => type?.label === job?.jobType
      );
      setValueJobTypes(filteredTypes[0]);

      const filteredCustomer = customers?.filter(
        type => parseInt(type?.value) === parseInt(job?.customerId)
      );
      setValueCustomer(filteredCustomer);

      const filteredSpecialty = optionsSpecialty?.filter(
        type => type?.label === job?.specialty
      );
      setValueSpecialty(filteredSpecialty);

      const filteredCertification = optionsCertification.filter(type =>
        job?.certification?.includes(type.label)
      );
      setValueCertification(filteredCertification);

      const filteredEMR = optionsEMR.filter(type =>
        job?.EMRorEHRExperience?.includes(type.label)
      );
      setValueEMR(filteredEMR);

      const filteredExperience = optionsExperienceLevel?.filter(
        type => type?.label === job?.yearOfExperience
      );
      setValueExperienceLevel(filteredExperience);

      setLoading(false);
    }
  }, [
    job,
    licenseTypes,
    jobTypes,
    optionsCertification,
    optionsEMR,
    customers,
    optionsSpecialty,
    duration,
    optionsExperienceLevel
  ]);

  useEffect(() => {
    if (jobId) {
      getJobDetail(jobId);
    }
  }, [jobId]);

  useEffect(() => {
    if (selectedJobTemplate) {
      setValueCustomer(
        customers?.filter(
          type => selectedJobTemplate?.origin?.customerName === type?.label
        )
      );
      setValueSpecialty(
        optionsCertification?.filter(
          type => selectedJobTemplate?.origin?.specialty === type?.label
        )
      );
      setValueCertification(
        optionsCertification.filter(type =>
          selectedJobTemplate?.origin?.certification?.includes(type.label)
        )
      );
      setValueEMR(
        licenseTypes.filter(type =>
          selectedJobTemplate?.origin?.EMRorEHRExperience?.includes(type.label)
        )
      );
      setValueExperienceLevel(
        customers?.filter(
          type => selectedJobTemplate?.origin?.yearOfExperience === type?.label
        )
      );
      setValueLicense(
        licenseTypes.filter(type =>
          selectedJobTemplate?.origin?.licenseType?.includes(type.label)
        )
      );

      const startTime = moment(selectedJobTemplate?.origin?.startTime);

      // Get the AM/PM format
      const startTimeAMPM = startTime.format('A'); // 'AM' or 'PM'

      // Get the hour in 12-hour format
      let shour = parseInt(startTime.format('hh'));

      // Adjust hour based on AM/PM
      if (startTimeAMPM === 'PM' && shour < 12) {
        shour += 12; // Convert PM hours to 24-hour format
      } else if (startTimeAMPM === 'AM' && shour === 12) {
        shour = 0; // Handle 12 AM case
      }

      // Create the endDate with adjusted hour
      const startDate = new Date(
        moment(formData?.startDate).format('YYYY'),
        moment(formData?.startDate).format('MM') - 1,
        moment(formData?.startDate).format('DD'),
        shour,
        moment(selectedJobTemplate?.origin?.startTime).format('mm'),
        moment(selectedJobTemplate?.origin?.startTime).format('ss'),
        0
      );

      const endTime = moment(selectedJobTemplate?.origin?.endTime);

      // Get the AM/PM format
      const endTimeAMPM = endTime.format('A'); // 'AM' or 'PM'

      // Get the hour in 12-hour format
      let hour = parseInt(endTime.format('hh'));

      // Adjust hour based on AM/PM
      if (endTimeAMPM === 'PM' && hour < 12) {
        hour += 12; // Convert PM hours to 24-hour format
      } else if (endTimeAMPM === 'AM' && hour === 12) {
        hour = 0; // Handle 12 AM case
      }

      // Create the endDate with adjusted hour
      const endDate = new Date(
        moment(formData?.endDate).format('YYYY'),
        moment(formData?.endDate).format('MM') - 1,
        moment(formData?.endDate).format('DD'),
        hour, // Use the adjusted hour
        moment(selectedJobTemplate?.origin?.endTime).format('mm'),
        moment(selectedJobTemplate?.origin?.endTime).format('ss'),
        0
      );

      const filterDuration = duration?.filter(
        type => type?.value === timeDifferentFun(startDate, endDate)
      );
      setValueDuration(filterDuration);

      // console.log(moment(startDate).toString());
      let e = moment(startDate).add('hours', filterDuration[0]?.value);
      // console.log(moment(e).toString());

      setFormData({
        ...formData,
        shiftTitle: selectedJobTemplate?.origin?.shiftTitle,
        break: selectedJobTemplate?.origin?.break,
        customerName: selectedJobTemplate?.origin?.customerName,
        customerId: selectedJobTemplate?.origin?.customerId,
        unit: selectedJobTemplate?.origin?.unit,
        floor: selectedJobTemplate?.origin?.floor,
        fullAddress: selectedJobTemplate?.origin?.fullAddress,
        latitude: selectedJobTemplate?.origin?.latitude,
        longitude: selectedJobTemplate?.origin?.longitude,
        baseRate: selectedJobTemplate?.origin?.baseRate,
        enableBid: selectedJobTemplate?.origin?.enableBid,
        autoAccept: selectedJobTemplate?.origin?.autoAcceptedEnable,
        notes: selectedJobTemplate?.origin?.notes,
        maxBaseRate: selectedJobTemplate?.origin?.maxBidAmount,
        jobTiming: selectedJobTemplate?.origin?.jobTiming,
        specialtyRequired: selectedJobTemplate?.origin?.specialtyRequired,
        certificationRequired:
          selectedJobTemplate?.origin?.certificationRequired,
        experienceRequired: selectedJobTemplate?.origin?.experienceRequired,
        emrehrRequired: selectedJobTemplate?.origin?.emrehrRequired,
        customerVisibility: selectedJobTemplate?.origin?.customerVisibility,
        baseRateVisibility: selectedJobTemplate?.origin?.baseRateVisibility,
        startDate: startDate,
        endDate: e
      });
    }
  }, [selectedJobTemplate]);

  // const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState('');

  const handleTimeChange = time => {
    setSelectedTime(time);
    let findAMorPM = time;
    const time24_1 = moment(findAMorPM, 'hh:mm A').format('HH:mm');
    formData?.startDate?.setHours(time24_1.toString()?.substring(0, 2));
    formData?.startDate?.setMinutes(time24_1.toString()?.substring(3, 5));
  };

  useEffect(() => {
    if (selectedTime !== '') {
      let date = formData?.startDate;
      let time = selectedTime;
      let findAMorPM = time;
      const time24_1 = moment(findAMorPM, 'hh:mm A').format('HH:mm');
      date?.setHours(time24_1.toString()?.substring(0, 2));
      date?.setMinutes(time24_1.toString()?.substring(3, 5));
      // console.log(date);
      // setFormData({
      //   ...formData,
      //   startDate: date
      // });
    }
  }, [selectedTime]);

  function GetDateMergedTime(date, time) {
    const date1 = moment(date).format('YYYY-MM-DD');
    const time1 = moment(time).format('hh:mm a');
    const mergedTime = moment(`${date1} ${time1}`, `YYYY-MM-DD hh:mm a`);
    return mergedTime;
  }

  function timeDifferent(sTime, eTime) {
    const startTime = moment(
      moment(new Date(sTime)).format('hh:mma'),
      'hh:mm A'
    );

    const start = moment(new Date(sTime));
    const end = moment(new Date(eTime));

    const endTime = moment(moment(new Date(eTime)).format('hh:mma'), 'hh:mm A');
    const endTimeEnd = moment(
      moment(new Date(eTime)).format('hh:mma'),
      'hh:mm A'
    ).add(1, 'day');

    const duration = moment.duration(endTime.diff(startTime));
    const durationEnd = moment.duration(endTimeEnd.diff(startTime));

    const hours = Math.floor(duration.asHours());
    const hoursEnd = Math.floor(durationEnd.asHours());
    const minutes = Math.floor(duration.asMinutes()) - hours * 60;

    // const onlyHours = `${
    //   end.hour() <= 12 && start.hour() <= 12
    //     ? hours
    //     : end.hour() <= 12
    //     ? hoursEnd
    //     : hours
    // } ${
    //   end.hour() <= 12 && start.hour() <= 12
    //     ? hours <= 1
    //       ? "hour"
    //       : "hours"
    //     : end.hour() <= 12
    //     ? hoursEnd <= 1
    //       ? "hour"
    //       : "hours"
    //     : hours <= 1
    //     ? "hour"
    //     : "hours"
    // }`;

    const onlyHours = `${
      end.hour() <= 12 && start.hour() <= 12
        ? hours
        : end.hour() <= 12
        ? hoursEnd
        : hours
    }${hours <= 1 ? 'hour' : 'hours'} ${
      minutes <= 0 ? '' : `${minutes}minutes`
    }`;

    return onlyHours;
  }

  const handleChange = ({ target }) => {
    let name = target.name;
    let value =
      name === 'customerVisibility'
        ? target.checked
        : name === 'baseRateEnable'
        ? target.checked
        : name === 'autoAccept'
        ? target.checked
        : name === 'slots'
        ? target.checked
        : name === 'publishJob'
        ? target.checked
        : name === 'directAssignment'
        ? target.checked
        : name === 'specialtyRequired'
        ? target.checked
        : name === 'certificationRequired'
        ? target.checked
        : name === 'emrehrRequired'
        ? target.checked
        : name === 'experienceRequired'
        ? target.checked
        : name === 'template'
        ? target.checked
        : name === 'enableBid'
        ? target.checked
        : target.value;
    setFormData({ ...formData, [name]: value });
  };

  const initMapScript = () => {
    if (window.google) {
      return Promise.resolve();
    }
    const src = `${mapApiJs}?key=${GOOGLE_PLACES_API_KEY}&libraries=places&v=weekly`;
    return loadAsyncScript(src);
  };

  const onChangeAddress = autocomplete => {
    const place = autocomplete.getPlace();
    handleChange({
      target: {
        name: 'fullAddress',
        value:
          extractAddress(place)?.street_number +
          ', ' +
          extractAddress(place)?.route +
          ', ' +
          extractAddress(place)?.locality +
          ', ' +
          extractAddress(place)?.administrative_area_level_3 +
          ', ' +
          extractAddress(place)?.administrative_area_level_2 +
          ', ' +
          extractAddress(place)?.administrative_area_level_1 +
          ', ' +
          extractAddress(place)?.country +
          ', ' +
          extractAddress(place)?.postal_code +
          ', ' +
          extractAddress(place)?.postal_code_suffix
      }
    });
    handleChange({
      target: {
        name: 'latitude',
        value: extractAddress(place)?.latitude
      }
    });
    handleChange({
      target: {
        name: 'longitude',
        value: extractAddress(place)?.longitude
      }
    });
  };

  const initAutocomplete = () => {
    if (!searchInput.current) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInput.current
    );
    autocomplete.setFields(['address_component', 'geometry']);
    autocomplete.addListener('place_changed', () =>
      onChangeAddress(autocomplete)
    );
  };

  const postJob = async () => {
    const ct = new Date(
      GetDateMergedTime(
        moment(formData?.startDate).format('YYYY-MM-DD'),
        formData?.startDate?.toString()
      ).toString()
    );
    const currentHour = ct.getHours();
    let jobTiming =
      currentHour >= 5 && currentHour < 12
        ? 'Morning'
        : currentHour >= 12 && currentHour < 17
        ? 'Afternoon'
        : currentHour >= 17 && currentHour < 20
        ? 'Evening'
        : 'Night';
    try {
      const item = await updateJobTable(authToken, jobId, {
        jobCompletedBy: 'Internal Pool',
        licenseType: valueLicense?.map(i => i?.label),
        shiftTitle: formData?.shiftTitle,
        specialty: valueSpecialty.length !== 0 ? valueSpecialty?.label : '',
        certification: valueCertification?.map(i => i?.label),
        yearOfExperience:
          valueExperienceLevel.length !== 0 ? valueExperienceLevel?.label : '',
        expiration: '0',
        startDate: moment(formData?.startDate).format('YYYY-MM-DD'),
        endDate: moment(formData?.endDate).format('YYYY-MM-DD'),
        startTime: GetDateMergedTime(
          moment(formData?.startDate).format('YYYY-MM-DD'),
          formData?.startDate?.toString()
        ).toString(),
        endTime: GetDateMergedTime(
          moment(formData?.endDate).format('YYYY-MM-DD'),
          formData?.endDate?.toString()
        ).toString(),
        break: formData?.break,
        customerName: formData?.customerName,
        customerId: formData?.customerId?.toString(),
        unit: formData?.unit,
        floor: formData?.floor,
        fullAddress: formData?.fullAddress,
        latitude: formData?.latitude?.toString(),
        longitude: formData?.longitude?.toString(),
        baseRate: formData.baseRate ? formData.baseRate : '1',
        enableBid: formData?.enableBid,
        notes: formData?.notes,
        jobType: valueJobTypes?.label,
        jobStatus: jobFinalSelectionNurseId === '' ? 'Open' : 'Nurse Assigned',
        jobFinalSelectionNurseId: jobFinalSelectionNurseId.toString(),
        jobBitFinalAmount: '',
        jobAcceptedNurses:
          jobFinalSelectionNurseId === '' ? [] : [jobFinalSelectionNurseId],
        jobRequestedNurses:
          jobFinalSelectionNurseId === ''
            ? []
            : [
                {
                  id: jobFinalSelectionNurseId,
                  type: 'Internal Pool'
                }
              ],
        autoAcceptedEnable: formData?.autoAccept,
        maxBidAmount: formData.maxBaseRate,
        jobDuration: timeDifferent(formData?.startDate, formData?.endDate),
        jobTiming: jobTiming,
        EMRorEHRExperience: valueEMR?.map(i => i?.label),
        specialtyRequired: formData.specialtyRequired,
        experienceRequired: formData.experienceRequired,
        emrehrRequired: formData.emrehrRequired,
        certificationRequired: formData.certificationRequired,
        customerVisibility: formData.customerVisibility,
        jobPostingTableFacilityTableId:
          formData.jobPostingTableFacilityTableId?.toString(),
        approved_manager:
          jobFinalSelectionNurseId === ''
            ? ''
            : formData.jobPostingTableFacilityTableId?.toString(),
        startDateTimeStamp: GetDateMergedTime(
          moment(formData?.startDate).format('YYYY-MM-DD'),
          formData.startDate?.toString()
        )
          .valueOf()
          .toString()
      });
      return item;
    } catch (error) {
      console.log('data save error:', error);
    }
  };

  const getAllData = async () => {
    try {
      const manList = await getAllFacilityOrgList(
        authToken,
        location,
        organization
      );

      const newManList = manList?.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );
      let manArray = [];

      for (let i = 0; i < newManList.length; i++) {
        const item = newManList[i];
        let obj = {
          id: item.id,
          value: item.id,
          uniqueId: item.uniqueId,
          name: item.firstName + ' ' + item.lastName,
          label: item.firstName + ' ' + item.lastName,
          profileImage: item.profileImage,
          emailId: item.emailId,
          facilityLoginControl: item?.facilityLoginControl
        };
        manArray.push(obj);
      }

      const cusList = await getCustomerTableList(
        authToken,
        location,
        organization
      );

      const list = cusList?.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );
      let array = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        let obj = {
          value: item.id,
          name: item.firstName + ' ' + item.lastName,
          label: item.firstName + ' ' + item.lastName,
          avatar: {
            name: item.firstName + ' ' + item.lastName
          },
          email: item.email,
          address: item.fullAddress,
          latitude: item.latitude,
          longitude: item.longitude,
          phone: item.phoneOne,
          status: item?.active,
          joined: item.createdAt,
          original: item
        };
        array.push(obj);
      }

      if (list.length === array.length) {
        setCustomers(array);
      }

      if (newManList.length === manArray.length) {
        setManagers(manArray);
      }

      // setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getTemplateBasedOnManager = async (id, type) => {
    await getTemplateType(authToken, id, type)
      .then(res => {
        if (res) {
          let array = [];
          // console.log("Template", res)
          for (let index = 0; index < res.length; index++) {
            const element = res[index];
            let obj = {
              value: index + 1,
              label: element?.jobTemplateName,
              origin: element
            };
            array.push(obj);
          }
          setJobTemplateArray(
            array?.sort((a, b) =>
              a?.label.toLowerCase().localeCompare(b?.label.toLowerCase())
            )
          );
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (formData?.jobPostingTableFacilityTableId) {
      getTemplateBasedOnManager(
        formData?.jobPostingTableFacilityTableId,
        valueJobTypes.label
      );
    }
  }, [formData, valueJobTypes]);

  useEffect(() => {
    if (authToken !== '') {
      getAllData();
    }
  }, [authToken, location, organization]);

  useEffect(() => {
    const get = async () => {
      setAvailableNurseLoading(true);
      await getJobMatchedAllNurse(
        authToken,
        organization,
        location,
        valueLicense?.map(i => i?.label),
        formData.fullAddress
      )
        .then(res => {
          // console.log("default", res)
          const data = res?.filter(nurseData => {
            const lowestYear = nurseData?.workExperienceDetails?.reduce(
              (lowest, employment) => {
                const year = new Date(employment?.startDate).getFullYear();
                return year < lowest ? year : lowest;
              },
              new Date().getFullYear()
            );
            const experience = new Date().getFullYear() - lowestYear;
            return (
              (formData?.specialtyRequired === true
                ? nurseData?.specialty?.includes(valueSpecialty[0]?.label)
                : formData?.specialtyRequired === false
                ? nurseData
                : nurseData) &&
              (formData?.certificationRequired === true
                ? valueCertification.some(value =>
                    nurseData?.certificationDetails?.some(
                      va => va?.certificationType === value?.label
                    )
                  )
                : formData?.certificationRequired === false
                ? nurseData
                : nurseData) &&
              (formData?.experienceRequired
                ? valueExperienceLevel[0]?.label === '0 - 1 year'
                  ? experience <= 1
                  : valueExperienceLevel[0]?.label === '1 - 2 years'
                  ? experience >= 1 && experience <= 2
                  : valueExperienceLevel[0]?.label === '2+ years'
                  ? experience >= 2
                  : true
                : formData?.experienceRequired === false
                ? nurseData
                : nurseData) &&
              (formData?.emrehrRequired === true
                ? valueEMR?.some(value =>
                    nurseData?.EMRorEHRExperience?.some(
                      va => va === value?.label
                    )
                  )
                : formData?.emrehrRequired === false
                ? nurseData
                : nurseData)
            );
          });
          // console.log('filter', data);
          setAvailableNurse(data);
          setAvailableNurseLoading(false);
        })
        .catch(e => console.log('getJobMatchedAllNurse', e));
    };
    if (
      valueCustomer.length !== 0 &&
      valueLicense.length !== 0 &&
      formData.fullAddress !== '' &&
      formData?.directAssignment === true
    ) {
      get();
    }
  }, [
    formData?.directAssignment,
    valueCustomer,
    valueLicense,
    valueCertification,
    valueExperienceLevel,
    valueSpecialty,
    valueEMR
  ]);

  function convertDate(dateString) {
    const d = moment(dateString).format('YYYY-MM-DD');
    return d;
  }

  useEffect(() => {
    const getNurseDirectAssignmentDates = async () => {
      if (jobFinalSelectionNurseId !== '') {
        if (
          convertDate(formData?.startDate) === convertDate(formData.endDate)
        ) {
          await getNurseWeekAvailabilityForDirectAssignment(
            authToken,
            jobFinalSelectionNurseId,
            convertDate(formData?.startDate),
            convertDate(formData?.endDate),
            moment(new Date(formData?.startDate)).format('hh:mm a'),
            moment(new Date(formData?.endDate)).format('hh:mm a'),
            selectedWeeks
          )
            .then(res => {
              // console.log("getNurseWeekAvailabilityForDirectAssignment", res)
              setWeekNurseDirectAssignmentAvailabilityData(res);
            })
            .catch(e =>
              console.log('getNurseWeekAvailabilityForDirectAssignment', e)
            );
        } else {
          await getNurseWeekAvailabilityForDirectAssignment(
            authToken,
            jobFinalSelectionNurseId,
            convertDate(formData?.startDate),
            convertDate(formData?.endDate),
            moment(new Date(formData?.startDate)).format('hh:mm a'),
            moment(new Date(formData?.endDate)).format('hh:mm a'),
            selectedWeeks
          )
            .then(res => {
              // console.log("getNurseWeekAvailabilityForDirectAssignment not same", res)
              setWeekNurseDirectAssignmentAvailabilityData(res);
            })
            .catch(e =>
              console.log(
                'getNurseWeekAvailabilityForDirectAssignment not same',
                e
              )
            );
        }
      } else {
        setWeekNurseDirectAssignmentAvailabilityData([]);
      }
    };
    getNurseDirectAssignmentDates();
  }, [
    formData.startDate,
    formData.endDate,
    jobFinalSelectionNurseId,
    selectedWeeks
  ]);

  const getNurseMatchedListId = async item => {
    const userList = await getAllNurseList(
      authToken,
      formData.jobPostingTableFacilityTableId
    );

    const deg2rad = deg => {
      return deg * (Math.PI / 180);
    };

    function getDistance(lat1, lon1, lat2, lon2) {
      const R = 6371; // Radius of the earth in km
      const dLat = deg2rad(lat2 - lat1);
      const dLon = deg2rad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) *
          Math.cos(deg2rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const d = R * c; // Distance in km
      return d / 1.609344; // Distance in miles
    }

    // userList.map((nurse) => console.log("user list", nurse?.id, nurse?.firstName, nurse?.mobileId));
    const data = userList.filter(nurseData => {
      // console.log(nurseData)
      // const lowestYear = nurseData?.workExperienceDetails?.reduce(
      //   (lowest, employment) => {
      //     const year = new Date(employment?.startDate).getFullYear();
      //     return year < lowest ? year : lowest;
      //   },
      //   new Date().getFullYear()
      // );
      // const experience = new Date().getFullYear() - lowestYear;
      return (
        item?.licenseType?.some(i => i === nurseData?.primaryLicenseType) &&
        item?.fullAddress?.includes(
          nurseData?.JobPreferencesNurse[0]?.notLicensedStateHideJobs
            ? nurseData?.primaryState
            : ''
        ) &&
        (nurseData?.JobPreferencesNurse[0]?.timing?.length !== 0
          ? nurseData?.JobPreferencesNurse[0]?.timing?.includes(item?.jobTiming)
          : item) &&
        (nurseData?.JobPreferencesNurse[0]?.days?.length !== 0
          ? nurseData?.JobPreferencesNurse[0]?.days?.includes(
              moment(item?.startDate).format('ddd')
            )
          : item) &&
        // getDistance(
        //   nurseData?.latitude,
        //   nurseData?.longitude,
        //   item?.latitude,
        //   item?.longitude
        // ).toFixed(0) >=
        //   (nurseData?.JobPreferencesNurse[0]?.minDistance === null
        //     ? 1
        //     : parseInt(nurseData?.JobPreferencesNurse[0]?.minDistance)) &&
        getDistance(
          nurseData?.latitude,
          nurseData?.longitude,
          item?.latitude,
          item?.longitude
        ).toFixed(0) <=
          (nurseData?.JobPreferencesNurse[0]?.maxDistance === null
            ? 100
            : parseInt(nurseData?.JobPreferencesNurse[0]?.maxDistance)) &&
        item?.baseRate >=
          (nurseData?.JobPreferencesNurse[0]?.minRate === null
            ? 1
            : parseInt(nurseData?.JobPreferencesNurse[0]?.minRate))
        //  &&
        //      &&
        // item?.baseRate <=
        //   (nurseData?.JobPreferencesNurse[0]?.maxRate === null
        //     ? 100
        //     : parseInt(nurseData?.JobPreferencesNurse[0]?.maxRate))
        // (item?.specialtyRequired === true
        //   ? nurseData?.specialty?.includes(item?.specialty)
        //   : item?.specialtyRequired === null
        //   ? item
        //   : item) &&
        // (item?.certificationRequired === true
        //   ? item?.certification.some((value) =>
        //       nurseData?.certificationDetails?.some(
        //         (va) => va?.certificationType === value
        //       )
        //     )
        //   : item?.certificationRequired === null
        //   ? item
        //   : item) &&
        // (item?.experienceRequired
        //   ? item?.yearOfExperience === "0 - 1 year"
        //     ? experience <= 1
        //     : item?.yearOfExperience === "1 - 2 years"
        //     ? experience >= 1 && experience <= 2
        //     : item?.yearOfExperience === "2+ years"
        //     ? experience >= 2
        //     : true
        //   : item?.experienceRequired === null
        //   ? item
        //   : item) &&
        // (item?.emrehrRequired === true
        //   ? item?.EMRorEHRExperience.some((value) =>
        //       nurseData?.EMRorEHRExperience?.some((va) => va === value)
        //     )
        //   : item?.emrehrRequired === null
        //   ? item
        //   : item)
      );
    });
    // data.map((nurse) => console.log("filter user list",nurse?.id, nurse?.firstName, nurse?.mobileId));
    return data;
  };

  const getNurseNotificationMobileId = async element => {
    const nurses = await getNurseMatchedListId(element);
    return nurses.map(nurse => nurse.mobileId);
  };

  const submit = async () => {
    if (
      formData?.directAssignment === true &&
      jobFinalSelectionNurseId === ''
    ) {
      setFormData({ ...formData, directAssignment: false });
      setFormData({ ...formData, publishJob: false });
      setLoadingButton(false);
      toast.warn('Select a nurse before publishing a job.', {
        theme: 'colored'
      });
    } else if (formData.baseRateEnable && formData.baseRate === '') {
      toast.warn('Enter base rate', {
        theme: 'colored'
      });
      setLoadingButton(false);
    } else {
      if (confirm('Confirm\nReview Date and Time before post?')) {
        setLoadingButton(true);
        try {
          setLoadingButton(true);
          await postJob().then(async res => {
            try {
              // console.log("res", res)
              const nurseIds = await getNurseNotificationMobileId(res);
              const flattenedIds = nurseIds.flat();
              const uniqueIds = [...new Set(flattenedIds)];
              // console.log(uniqueIds)
              setUserList(uniqueIds);
              setJobCreated(true);
            } catch (error) {
              return console.error(error);
            }
          });
        } catch (error) {
          console.error(error);
          setLoadingButton(false);
        }
      } else {
        setLoadingButton(false);
      }
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    submit();
  };

  const pushNotification = async nurse => {
    if (nurse[0]?.mobileId) {
      sendNotification(authToken, {
        expoPushToken: nurse[0]?.mobileId,
        title: `“Direct ${valueJobTypes?.label}s Assignment” (Check Upcoming Jobs)`,
        body: `${valueJobTypes?.label}s assigned.`,
        data: { screen: 'HomeScreen' }
      });
    }
    await postNurseNotification(
      authToken,
      nurse[0]?.id,
      '',
      `“Direct ${valueJobTypes?.label}s Assignment” (Check Upcoming Jobs)`,
      `${valueJobTypes?.label}s assigned.`,
      'HomeScreen',
      {
        screen: 'UpComing'
      },
      false,
      false,
      'green',
      ''
    );
    socket?.emit('tableNotificationInsert', {
      table: 'NurseNotificationTable',
      id: nurse[0]?.id
    });
    socket?.emit('tableJobInsert', {
      table: 'JobPostingTable',
      message: 'Fetch Dashboard Job'
    });
  };

  useEffect(() => {
    if (jobFinalSelectionNurseId === '') {
      if (jobCreated) {
        // console.log("jobCreated", jobCreated)
        // console.log("userList", userList)
        userList?.map(async item => {
          if (item) {
            sendNotification(authToken, {
              expoPushToken: item,
              title: 'New Jobs',
              body: `${valueJobTypes?.label}s available in your area.`,
              data: { screen: 'HomeScreen' }
            });
          }
        });
        socket?.emit('tableJobInsert', {
          table: 'JobPostingTable',
          message: 'Fetch Dashboard Job'
        });
        toast.success('Jobs Post Successful.', {
          theme: 'colored'
        });
        setValueLicense([]);
        setValueManager([]);
        setValueCustomer([]);
        setValueSpecialty([]);
        setValueCertification([]);
        setValueEMR([]);
        setValueExperienceLevel([]);
        setValueDuration([]);
        setValueSlots([]);
        setAvailableNurse([]);
        setSelectedWeeks('1');
        setWeekNurseDirectAssignmentAvailabilityData([]);
        setUserList([]);
        setJobFinalSelectionNurseId('');
        setLoadingButton(false);
        setJobCreated(false);
        setValueJobTypes({
          value: '1',
          label: 'Shift'
        });
        setFormData({
          shiftTitle: '',
          startDate: new Date(),
          endDate: new Date(),
          break: 'No Break',
          customerName: null,
          customerId: '',
          unit: '',
          floor: '',
          fullAddress: '',
          latitude: '',
          longitude: '',
          notes: '',
          jobType: 'Shift',
          jobTiming: '',
          customerVisibility: false,
          autoAccept: false,
          slots: false,
          baseRate: '',
          maxBaseRate: '',
          baseRateEnable: false,
          enableBid: false,
          publishJob: false,
          template: false,
          jobTemplateName: '',
          jobPostingTableFacilityTableId: '',
          jobPostingTableFacilityTableName: '',
          specialtyRequired: false,
          certificationRequired: false,
          experienceRequired: false,
          emrehrRequired: false,
          directAssignment: false
        });
        navigate(paths.nursd_schedule);
      }
    } else {
      if (jobCreated) {
        const nurse = weekNurseDirectAssignmentAvailabilityData
          .flat()
          .filter(item => {
            return item?.uniqueId === jobFinalSelectionNurseId;
          });
        pushNotification(nurse);
        toast.success('Jobs Post Successful.', {
          theme: 'colored'
        });
        setValueLicense([]);
        setValueManager([]);
        setValueCustomer([]);
        setValueSpecialty([]);
        setValueCertification([]);
        setValueEMR([]);
        setValueExperienceLevel([]);
        setValueDuration([]);
        setValueSlots([]);
        setAvailableNurse([]);
        setSelectedWeeks('1');
        setWeekNurseDirectAssignmentAvailabilityData([]);
        setUserList([]);
        setJobFinalSelectionNurseId('');
        setLoadingButton(false);
        setJobCreated(false);
        setFormData({
          shiftTitle: '',
          startDate: new Date(),
          endDate: new Date(),
          break: 'No Break',
          customerName: null,
          customerId: '',
          unit: '',
          floor: '',
          fullAddress: '',
          latitude: '',
          longitude: '',
          notes: '',
          jobType: 'Shift',
          jobTiming: '',
          customerVisibility: false,
          autoAccept: false,
          slots: false,
          baseRate: '',
          maxBaseRate: '',
          baseRateEnable: false,
          enableBid: false,
          publishJob: false,
          template: false,
          jobTemplateName: '',
          jobPostingTableFacilityTableId: '',
          jobPostingTableFacilityTableName: '',
          specialtyRequired: false,
          certificationRequired: false,
          experienceRequired: false,
          emrehrRequired: false,
          directAssignment: false
        });

        navigate(-1);
      }
    }
  }, [userList, jobCreated]);

  const [CNA, setCNA] = useState([]);
  const [LPN, setLPN] = useState([]);
  const [HHA, setHHA] = useState([]);
  const [RN, setRN] = useState([]);

  useEffect(() => {
    let cnaArray = [];
    let lpnArray = [];
    let hhaArray = [];
    let rnArray = [];

    if (formData.directAssignment && availableNurse?.length !== 0) {
      for (let index = 0; index < availableNurse?.length; index++) {
        const element = availableNurse[index];
        if (element?.license === 'CNA') {
          // console.log(element);
          cnaArray.push(element);
        } else if (element?.license === 'LPN') {
          lpnArray.push(element);
        } else if (element?.license === 'HHA') {
          hhaArray.push(element);
        } else if (element?.license === 'RN') {
          rnArray.push(element);
        }
      }
    }

    setCNA(cnaArray);
    setLPN(lpnArray);
    setHHA(hhaArray);
    setRN(rnArray);
  }, [availableNurse]);

  return (
    <Card>
      {loading ? (
        <Card.Header>
          <h5 className="mb-0">Loading...</h5>
        </Card.Header>
      ) : (
        <>
          <Card.Header>
            <Flex justifyContent={'between'}>
              <h5 className="mt-3">Update Schedule</h5>
            </Flex>
          </Card.Header>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <div className="px-3">
                <Row className="mb-2">
                  <Form.Group
                    as={Col}
                    md="4"
                    className="mb-2"
                    controlId="JobType"
                  >
                    <Form.Label className="fs-9">Job Type</Form.Label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      placeholder="Select..."
                      isClearable
                      isSearchable
                      name="color"
                      value={valueJobTypes}
                      onChange={value => {
                        setValueJobTypes(
                          value
                            ? value
                            : {
                                value: '1',
                                label: 'Shift'
                              }
                        );
                      }}
                      options={jobTypes}
                      components={animatedComponents}
                      required
                    />
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="4"
                    className="mb-2"
                    controlId="Manager"
                  >
                    <Form.Label className="fs-9">Manager</Form.Label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      placeholder="Select..."
                      isClearable
                      isSearchable
                      name="color"
                      value={valueManager}
                      onChange={value => {
                        setValueManager(value);
                        setFormData({
                          ...formData,
                          jobPostingTableFacilityTableName: value?.label,
                          jobPostingTableFacilityTableId: value?.id
                        });
                      }}
                      options={managers}
                      components={animatedComponents}
                      required
                    />
                  </Form.Group>
                  {formData.jobPostingTableFacilityTableId && (
                    <Form.Group
                      as={Col}
                      md="4"
                      className="mb-2"
                      controlId="License"
                    >
                      <Form.Label className="fs-9">Template</Form.Label>
                      <Select
                        closeMenuOnSelect={false}
                        options={jobTemplateArray}
                        placeholder="Select..."
                        classNamePrefix="react-select"
                        value={selectedJobTemplate}
                        onChange={value => {
                          setSelectedJobTemplate(value);
                        }}
                        components={animatedComponents}
                      />
                    </Form.Group>
                  )}
                  <Form.Group
                    as={Col}
                    md="4"
                    className="mb-2"
                    controlId="License"
                  >
                    <Form.Label className="fs-9">License</Form.Label>
                    <Select
                      closeMenuOnSelect={false}
                      options={licenseTypes}
                      placeholder="Select..."
                      isMulti
                      classNamePrefix="react-select"
                      value={valueLicense}
                      onChange={value => {
                        setValueLicense(value);
                      }}
                      components={animatedComponents}
                      required
                    />
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md={8}
                    className="mb-2"
                    controlId="shiftTitle"
                  >
                    <Form.Label className="fs-9">Title</Form.Label>
                    <Form.Control
                      type="text"
                      name="shiftTitle"
                      placeholder="Title"
                      required
                      value={formData?.shiftTitle}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Row>
                <Row className="mb-2">
                  <Form.Group
                    as={Col}
                    md={valueJobTypes?.label === 'Shift' ? '3' : '4'}
                    className="mb-2"
                    controlId="startDate"
                  >
                    <Form.Label className="fs-9">Start</Form.Label>
                    <div
                      style={{
                        border: '1px solid rgba(0, 0, 0, 0.1)',
                        display: 'flex',
                        flexDirection: 'row',
                        borderRadius: 5,
                        boxShadow: '0 1px 1px rgba(0, 0, 0, 0.1)',
                        padding: '5px 2px',
                        overflowY: 'auto'
                      }}
                    >
                      <DatePicker
                        selected={formData?.startDate}
                        minDate={moment().toDate()}
                        minTime={
                          moment(formData?.startDate).format('MM/DD/YYYYY') ===
                          moment().format('MM/DD/YYYYY')
                            ? moment().toDate() // Set minTime to current time if today
                            : new Date(0, 0, 0, 0, 0, 0) // If it's another day, set minTime to 00:00
                        }
                        maxTime={new Date(0, 0, 0, 23, 59, 59)} // Limit the maximum time to the end of the day
                        onChange={v => {
                          if (valueJobTypes?.label === 'Visit') {
                            let date = moment(new Date(v)).add('hour', 1);
                            // console.log({
                            //   startDate: v,
                            //   endDate: new Date(date)
                            // });
                            setFormData({
                              ...formData,
                              startDate: v,
                              endDate: new Date(date)
                            });
                          } else {
                            // console.log({
                            //   startDate: v
                            // });
                            let fst = moment(formData.startDate).format(
                              'hh:mm a'
                            );
                            let nsd = moment(v).format('YYYY-MM-DD');
                            let sd = moment(`${nsd} ${fst}`).toString();
                            // console.log(valueDuration);
                            if (valueDuration === null) {
                              setFormData({
                                ...formData,
                                startDate: new Date(sd),
                                endDate: new Date(sd)
                              });
                              // console.log('if', new Date(sd));
                            } else {
                              let e = moment(sd)
                                .add('hours', valueDuration[0]?.value)
                                .toString();
                              // console.log('else', new Date(sd));
                              // console.log('else', new Date(e));
                              setFormData({
                                ...formData,
                                startDate: new Date(sd),
                                endDate: new Date(e)
                              });
                            }
                          }
                        }}
                        className="form-control"
                        placeholderText="MM-DD-YYYY"
                        dateFormat="MM-dd-yyyy"
                      />
                      <TimeDropdown
                        time={formData.startDate}
                        selectedDate={formData.startDate}
                        selectedTime={selectedTime}
                        handleTimeChange={handleTimeChange}
                      />
                    </div>
                  </Form.Group>
                  {valueJobTypes?.label === 'Shift' && (
                    <Form.Group
                      as={Col}
                      md="3"
                      className="mb-2"
                      controlId="Duration"
                    >
                      <Form.Label className="fs-9">Duration</Form.Label>
                      <Select
                        required
                        className="basic-single"
                        classNamePrefix="select"
                        placeholder="Select..."
                        isClearable
                        isSearchable
                        name="color"
                        value={valueDuration}
                        onChange={value => {
                          setValueDuration(value);

                          let date = new Date();
                          let dateEnd = new Date();
                          let newEnd = new Date(formData.startDate);
                          let selectedHourTime =
                            newEnd.getHours() === 0
                              ? 12
                              : newEnd.getHours() > 12
                              ? newEnd.getHours() - 12
                              : newEnd.getHours();
                          let selectedMinuteTime = newEnd
                            .getMinutes()
                            .toString()
                            .padStart(2, '0');
                          let selectedAPTime =
                            newEnd.getHours() >= 12 ? 'PM' : 'AM';

                          date.setHours(
                            selectedAPTime === 'AM' && selectedHourTime === 12
                              ? 0
                              : selectedAPTime === 'PM' &&
                                selectedHourTime === 12
                              ? 12
                              : selectedHourTime !== 12 &&
                                selectedAPTime === 'PM'
                              ? parseInt(selectedHourTime) + 12
                              : parseInt(selectedHourTime)
                          );
                          date.setMinutes(selectedMinuteTime);
                          date.setFullYear(newEnd.getFullYear());
                          date.setMonth(newEnd.getMonth());
                          date.setDate(newEnd.getDate());

                          // Add 8 hours to dateEnd based on date
                          dateEnd.setFullYear(date.getFullYear());
                          dateEnd.setMonth(date.getMonth());
                          dateEnd.setDate(date.getDate());
                          dateEnd.setHours(date.getHours() + value?.value);
                          dateEnd.setMinutes(date.getMinutes());

                          // Determine if it's AM or PM
                          let meridiem = dateEnd.getHours() >= 12 ? 'PM' : 'AM';

                          if (selectedAPTime === 'PM' && meridiem === 'AM') {
                            // let endDate = moment(formData.startDate);
                            // endDate.add(1, 'day');
                            setFormData({
                              ...formData,
                              startDate: date,
                              endDate: dateEnd
                            });
                          } else {
                            setFormData({
                              ...formData,
                              startDate: date,
                              endDate: dateEnd
                            });
                          }
                        }}
                        options={duration}
                        components={animatedComponents}
                      />
                    </Form.Group>
                  )}
                  <Form.Group
                    as={Col}
                    md={valueJobTypes?.label === 'Shift' ? '3' : '4'}
                    className="mb-2"
                    controlId="End"
                  >
                    <Form.Label className="fs-9">End</Form.Label>
                    <Form.Control
                      type="text"
                      name="End"
                      disabled
                      value={moment(formData?.endDate).format(
                        'MM-DD-YYYY hh:mm A'
                      )}
                    />
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md={valueJobTypes?.label === 'Shift' ? '3' : '4'}
                    className="mb-2"
                    controlId="Break"
                  >
                    <Form.Label className="fs-9">Break</Form.Label>
                    <Form.Select
                      name="className"
                      onChange={event => {
                        const value = event.target.value;
                        let date = new Date(formData.endDate);
                        let dateEnd = new Date(formData.endDate);
                        dateEnd.setFullYear(date.getFullYear());
                        dateEnd.setMonth(date.getMonth());
                        dateEnd.setDate(date.getDate());
                        dateEnd.setHours(
                          value === '1 Hour'
                            ? date.getHours() + 1
                            : date.getHours()
                        );
                        dateEnd.setMinutes(
                          value === '15 Minutes'
                            ? date.getMinutes() + 15
                            : value === '30 Minutes'
                            ? date.getMinutes() + 30
                            : value === '45 Minutes'
                            ? date.getMinutes() + 45
                            : date.getMinutes()
                        );
                        setFormData({
                          ...formData,
                          break: value,
                          endDate: dateEnd
                        });
                      }}
                      value={formData?.break}
                      required
                    >
                      <option value="No Break">No Break</option>
                      <option value="15 Minutes">15 Minutes</option>
                      <option value="30 Minutes">30 Minutes</option>
                      <option value="45 Minutes">45 Minutes</option>
                      <option value="1 Hour">1 Hour</option>
                    </Form.Select>
                  </Form.Group>
                </Row>
                <Row className="mb-2">
                  <Form.Group
                    as={Col}
                    md={6}
                    className="mb-2"
                    controlId="Customer"
                  >
                    <Form.Label className="fs-9">Patient</Form.Label>
                    <Select
                      required
                      className="basic-single"
                      classNamePrefix="select"
                      placeholder="Select..."
                      isClearable
                      isSearchable
                      name="color"
                      value={valueCustomer}
                      onChange={value => {
                        setValueCustomer(value ? value : []);
                        if (value) {
                          setFormData({
                            ...formData,
                            customerName: value?.label,
                            customerId: value?.value,
                            fullAddress: value?.address,
                            latitude: value?.latitude,
                            longitude: value?.longitude
                          });
                        } else {
                          setFormData({
                            ...formData,
                            customerName: null,
                            customerId: '',
                            fullAddress: '',
                            latitude: '',
                            longitude: ''
                          });
                        }
                      }}
                      options={customers}
                      components={animatedComponents}
                    />
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="6"
                    className="mb-2"
                    controlId="FullAddress"
                  >
                    <Form.Label className="fs-9">Full Address</Form.Label>
                    <Form.Control
                      required
                      ref={searchInput}
                      contentEditable={false}
                      type="text"
                      placeholder="Full Address"
                      value={formData?.fullAddress}
                    />
                  </Form.Group>
                </Row>
                <Row className="mb-2">
                  <Form.Group as={Col} md="4" className="mb-2" controlId="Unit">
                    <Form.Label className="fs-9">Unit</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Unit"
                      value={formData?.unit}
                      name="unit"
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="4"
                    className="mb-2"
                    controlId="Floor"
                  >
                    <Form.Label className="fs-9">Floor</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Floor"
                      name="floor"
                      value={formData?.floor}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="4"
                    className="mb-2 pt-4"
                    controlId="customerVisibility"
                  >
                    <Form.Check
                      type="checkbox"
                      id="customerVisibility"
                      label="Customer Visible After Assignment"
                      name="customerVisibility"
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group
                    as={Col}
                    md="6"
                    className="mb-2"
                    controlId="License"
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Form.Label className="fs-9">Select Specialty</Form.Label>
                      <Form.Group
                        controlId="specialtyRequired"
                        className="mx-2"
                      >
                        <Form.Check
                          type="checkbox"
                          id="specialtyRequired"
                          label="Specialty Required"
                          name="specialtyRequired"
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <Select
                      required={formData.specialtyRequired}
                      isClearable
                      closeMenuOnSelect={false}
                      options={optionsSpecialty}
                      placeholder="Select..."
                      classNamePrefix="react-select"
                      value={valueSpecialty}
                      onChange={value => {
                        setValueSpecialty(value);
                      }}
                      components={animatedComponents}
                    />
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="6"
                    className="mb-2"
                    controlId="License"
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Form.Label className="fs-9">
                        Select Certification
                      </Form.Label>
                      <Form.Group
                        controlId="certificationRequired"
                        className="mx-2"
                      >
                        <Form.Check
                          type="checkbox"
                          id="certificationRequired"
                          label="Certification Required"
                          name="certificationRequired"
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <Select
                      required={formData.certificationRequired}
                      closeMenuOnSelect={false}
                      options={optionsCertification}
                      placeholder="Select..."
                      isMulti
                      classNamePrefix="react-select"
                      value={valueCertification}
                      onChange={value => {
                        setValueCertification(value);
                      }}
                      components={animatedComponents}
                    />
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group
                    as={Col}
                    md="6"
                    className="mb-2"
                    controlId="License"
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Form.Label className="fs-9">
                        Select ExperienceLevel
                      </Form.Label>
                      <Form.Group
                        controlId="experienceRequired"
                        className="mx-2"
                      >
                        <Form.Check
                          type="checkbox"
                          id="experienceRequired"
                          label="ExperienceLevel Required"
                          name="experienceRequired"
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <Select
                      required={formData.experienceRequired}
                      isClearable
                      closeMenuOnSelect={false}
                      options={optionsExperienceLevel}
                      placeholder="Select..."
                      classNamePrefix="react-select"
                      value={valueExperienceLevel}
                      onChange={value => {
                        setValueExperienceLevel(value);
                      }}
                      components={animatedComponents}
                    />
                  </Form.Group>
                  <Form.Group
                    as={Col}
                    md="6"
                    className="mb-2"
                    controlId="License"
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Form.Label className="fs-9">
                        Select EMR/EHR Experience
                      </Form.Label>
                      <Form.Group controlId="emrehrRequired" className="mx-2">
                        <Form.Check
                          type="checkbox"
                          id="emrehrRequired"
                          label="EMR/EHR Required"
                          name="emrehrRequired"
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <Select
                      required={formData.emrehrRequired}
                      closeMenuOnSelect={false}
                      options={optionsEMR}
                      placeholder="Select..."
                      isMulti
                      classNamePrefix="react-select"
                      value={valueEMR}
                      onChange={value => {
                        setValueEMR(value);
                      }}
                      components={animatedComponents}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group
                    as={Col}
                    md="2"
                    className="mb-2"
                    controlId="baseRateEnable"
                  >
                    <Form.Check
                      type="checkbox"
                      id="baseRateEnable"
                      label="Base Rate"
                      name="baseRateEnable"
                      onChange={handleChange}
                    />
                  </Form.Group>
                  {formData?.baseRateEnable && (
                    <Form.Group as={Col} md="4" controlId="baseRate">
                      <Form.Label>Base Rate</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        placeholder="Base Rate"
                        name="baseRate"
                        value={formData.baseRate}
                        onChange={handleChange}
                        pattern="[0-9]*"
                      />
                    </Form.Group>
                  )}
                  {formData?.baseRateEnable && (
                    <Form.Group
                      as={Col}
                      md="2"
                      className="mb-2"
                      controlId="enableBid"
                    >
                      <Form.Check
                        type="checkbox"
                        id="enableBid"
                        label="Enable Bid"
                        name="enableBid"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  )}
                  {formData?.enableBid && (
                    <Form.Group as={Col} md="4" controlId="maxBaseRate">
                      <Form.Label>Max Bid Rate</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        placeholder="Max Bid Rate"
                        name="maxBaseRate"
                        value={formData.maxBaseRate}
                        onChange={handleChange}
                        pattern="[0-9]*"
                      />
                    </Form.Group>
                  )}
                </Row>
                <Form.Group className="mb-3" controlId="notes">
                  <Form.Label className="fs-9">Notes</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="notes"
                    onChange={handleChange}
                  />
                </Form.Group>
                <Row>
                  {!formData.directAssignment && (
                    <Form.Group
                      as={Col}
                      md="3"
                      className="mb-2"
                      controlId="autoAccept"
                    >
                      <Form.Check
                        type="checkbox"
                        id="autoAccept"
                        label="Enable Auto Assigned"
                        name="autoAccept"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  )}
                  {!formData?.autoAccept &&
                    !formData.slots &&
                    !formData.template && (
                      <Form.Group
                        as={Col}
                        md="3"
                        className="mb-2"
                        controlId="directAssignment"
                      >
                        <Form.Check
                          type="checkbox"
                          id="directAssignment"
                          label="Enable Direct Assignment"
                          name="directAssignment"
                          onChange={e => {
                            if (
                              valueLicense.length === 0 &&
                              valueCustomer.length === 0
                            ) {
                              toast.warning('Select License and patient', {
                                theme: 'colored'
                              });
                            } else {
                              handleChange(e);
                            }
                          }}
                          checked={formData?.directAssignment}
                        />
                      </Form.Group>
                    )}
                </Row>
                <Row>
                  {formData?.slots && (
                    <Form.Group
                      as={Col}
                      md="12"
                      className="mb-2"
                      controlId="Slots"
                    >
                      <Form.Label className="fs-9">Slots</Form.Label>
                      <Select
                        required
                        className="basic-single"
                        classNamePrefix="select"
                        placeholder="Select..."
                        isClearable
                        isSearchable
                        name="color"
                        value={valueSlots}
                        onChange={value => {
                          setValueSlots(value);
                        }}
                        options={slots}
                        components={animatedComponents}
                      />
                    </Form.Group>
                  )}
                </Row>
                <Row>
                  {formData.directAssignment && (
                    <div style={{ marginTop: 10 }}>
                      <h6
                        style={{
                          marginHorizontal: 20,
                          fontSize: 12,
                          color: '#888'
                        }}
                      >
                        Select a nurse to check availability.
                      </h6>
                      <Row
                        style={{
                          marginTop: 10
                        }}
                      >
                        {availableNurseLoading ? (
                          <h6
                            style={{
                              fontWeight: '500',
                              fontSize: 12,
                              textAlign: 'left'
                            }}
                          >
                            Loading...
                          </h6>
                        ) : availableNurse?.length === 0 ? (
                          <h6
                            style={{
                              fontWeight: '500',
                              fontSize: 12,
                              textAlign: 'left'
                            }}
                          >
                            No matches found
                          </h6>
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              flexWrap: 'wrap',
                              WebkitFlexWrap: 'wrap'
                            }}
                          >
                            {CNA?.length !== 0 && (
                              <div style={{}}>
                                <h5 className="mx-2">CNA License's</h5>
                                {CNA?.map((item, index) => {
                                  return (
                                    <UserJobCard
                                      key={index}
                                      element={item}
                                      jobFinalSelectionNurseId={
                                        jobFinalSelectionNurseId
                                      }
                                      setWeekNurseDirectAssignmentAvailabilityData={
                                        setWeekNurseDirectAssignmentAvailabilityData
                                      }
                                      setJobFinalSelectionNurseId={
                                        setJobFinalSelectionNurseId
                                      }
                                    />
                                  );
                                })}
                              </div>
                            )}
                            {LPN?.length !== 0 && (
                              <div style={{}}>
                                <h5 className="mx-2">LPN License's</h5>
                                {LPN?.map((item, index) => {
                                  return (
                                    <UserJobCard
                                      key={index}
                                      element={item}
                                      jobFinalSelectionNurseId={
                                        jobFinalSelectionNurseId
                                      }
                                      setWeekNurseDirectAssignmentAvailabilityData={
                                        setWeekNurseDirectAssignmentAvailabilityData
                                      }
                                      setJobFinalSelectionNurseId={
                                        setJobFinalSelectionNurseId
                                      }
                                    />
                                  );
                                })}
                              </div>
                            )}
                            {HHA?.length !== 0 && (
                              <div style={{}}>
                                <h5 className="mx-2">HHA License's</h5>
                                {HHA?.map((item, index) => {
                                  return (
                                    <UserJobCard
                                      key={index}
                                      element={item}
                                      jobFinalSelectionNurseId={
                                        jobFinalSelectionNurseId
                                      }
                                      setWeekNurseDirectAssignmentAvailabilityData={
                                        setWeekNurseDirectAssignmentAvailabilityData
                                      }
                                      setJobFinalSelectionNurseId={
                                        setJobFinalSelectionNurseId
                                      }
                                    />
                                  );
                                })}
                              </div>
                            )}
                            {RN?.length !== 0 && (
                              <div style={{}}>
                                <h5 className="mx-2">RN License's</h5>
                                {RN?.map((item, index) => {
                                  return (
                                    <UserJobCard
                                      key={index}
                                      element={item}
                                      jobFinalSelectionNurseId={
                                        jobFinalSelectionNurseId
                                      }
                                      setWeekNurseDirectAssignmentAvailabilityData={
                                        setWeekNurseDirectAssignmentAvailabilityData
                                      }
                                      setJobFinalSelectionNurseId={
                                        setJobFinalSelectionNurseId
                                      }
                                    />
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        )}
                      </Row>
                      <h6
                        style={{
                          marginHorizontal: 20,
                          fontSize: 12,
                          color: '#888',
                          marginTop: 10
                        }}
                      >
                        Select Post Job before submit.
                      </h6>
                    </div>
                  )}
                </Row>
                <Row className="mt-2">
                  {!formData.template && (
                    <Form.Group as={Col} md="3" controlId="publishJob">
                      <Form.Check
                        required
                        type="checkbox"
                        id="publishJob"
                        label="Post Job"
                        name="publishJob"
                        onChange={handleChange}
                      />
                    </Form.Group>
                  )}
                </Row>
              </div>

              <Flex className="mt-2">
                <Button variant="primary" type="submit">
                  {loadingButton ? 'Loading...' : 'Publish'}
                </Button>
                <Button
                  as={Link}
                  to={paths.nursd_schedule}
                  variant="secondary"
                  className="mx-2"
                >
                  Cancel
                </Button>
              </Flex>
            </Form>
          </Card.Body>
        </>
      )}
    </Card>
  );
};

export default Create_Schedule;
